import React from 'react';

const TypescriptIcon = () => {
  return <img src='/skill-icons/typescript.png' alt='typescript-logo' />;
};

export default TypescriptIcon;
